import React from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Box,
  Typography,
  TextField,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import { Trash2 } from "lucide-react";
import ColumnHeaderWithSearch from "../../SearchBar";

const getSettingColumns = ({
  anchorEl,
  selectedUserId,
  handleMenuClick,
  handleMenuClose,
  handleEdit,
  handleDelete,
  handleColumnFilter,
  columnFilters,
}) => [
  { 
    field: "USER_NAME", 
    headerName: "Username", 
    flex: 1, 
    filterable: true,
    align: "left",
    headerAlign: "left",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title={params.colDef.headerName || params.field}
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="left"
      />
    )
  },
  { 
    field: "USER_EMAIL", 
    headerName: "Email", 
    flex: 1, 
    filterable: true,
    align: "left",
    headerAlign: "left",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title={params.colDef.headerName || params.field}
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="left"
      />
    )
  },
  { 
    field: "CONTACT_NO", 
    headerName: "Contact", 
    flex: 1, 
    filterable: true,
    align: "left",
    headerAlign: "left",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title={params.colDef.headerName || params.field}
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="left"
      />
    )
  },
  { 
    field: "TOTAL_LICENSES", 
    headerName: "Licenses", 
    flex: 1, 
    filterable: true,
    align: "right",
    headerAlign: "right",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title={params.colDef.headerName || params.field}
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="right"
      />
    )
  },
  {
    field: "STATUS",
    headerName: "Status",
    flex: 1,
    filterable: true,
    align: "center",
    headerAlign: "center",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title={params.colDef.headerName || params.field}
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="center"
      />
    ),
    renderCell: (params) => {
      const status = params.row.STATUS;
      const isActive = status === 'ACTIVE';
      
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Chip
            label={status || 'Unknown'}
            color={isActive ? "success" : "default"}
            size="small"
            variant="outlined"
            sx={{
              fontWeight: 500,
              fontSize: '0.75rem',
              '&.MuiChip-outlined': {
                borderColor: isActive ? '#4caf50' : '#9e9e9e',
                color: isActive ? '#4caf50' : '#9e9e9e',
              }
            }}
          />
        </Box>
      );
    },
  },
  { 
    field: "USER_ROLE", 
    headerName: "Role", 
    flex: 1, 
    filterable: true,
    align: "left",
    headerAlign: "left",
    renderHeader: (params) => (
      <ColumnHeaderWithSearch
        title={params.colDef.headerName || params.field}
        value={columnFilters[params.field]}
        onChange={(value) => handleColumnFilter(params.field, value)}
        align="left"
      />
    )
  },
  {
    field: "actions",
    headerName: "Actions",
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
     return <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <IconButton
          aria-label="actions"
          onClick={(e) => handleMenuClick(e, params.row.USER_AUTH_ID)}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl) && selectedUserId === params.row.USER_AUTH_ID}
          onClose={handleMenuClose}
        >


          <MenuItem onClick={handleEdit}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>

          <MenuItem 
            onClick={() => handleDelete(params.row.USER_AUTH_ID)}
            disabled={params.row.STATUS !== 'ACTIVE'}
            sx={{
              opacity: params.row.STATUS !== 'ACTIVE' ? 0.5 : 1,
              cursor: params.row.STATUS !== 'ACTIVE' ? 'not-allowed' : 'pointer'
            }}
          >
            <ListItemIcon>
              <Trash2 fontSize="small" />
            </ListItemIcon>
            <ListItemText>
              {params.row.STATUS === 'ACTIVE' ? 'Deactivate User' : 'User Already Inactive'}
            </ListItemText>
          </MenuItem>
        </Menu>
      </Box>
    },
  },
];

export default getSettingColumns;